import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function PlusIconCircleBorder(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        d="M5.33333 2.66669C5.60948 2.66669 5.83333 2.89054 5.83333 3.16669V4.83333H7.5C7.77614 4.83333 8 5.05719 8 5.33333C8 5.60948 7.77614 5.83333 7.5 5.83333H5.83333V7.5C5.83333 7.77614 5.60948 8 5.33333 8C5.05719 8 4.83333 7.77614 4.83333 7.5V5.83333H3.16667C2.89052 5.83333 2.66667 5.60948 2.66667 5.33333C2.66667 5.05719 2.89052 4.83333 3.16667 4.83333H4.83333V3.16669C4.83333 2.89054 5.05719 2.66669 5.33333 2.66669Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.33333C0 2.38782 2.38782 0 5.33333 0C8.27888 0 10.6667 2.38782 10.6667 5.33333C10.6667 8.27888 8.27888 10.6667 5.33333 10.6667C2.38782 10.6667 0 8.27888 0 5.33333ZM5.33333 1C2.9401 1 1 2.9401 1 5.33333C1 7.72659 2.9401 9.66667 5.33333 9.66667C7.72659 9.66667 9.66667 7.72659 9.66667 5.33333C9.66667 2.9401 7.72659 1 5.33333 1Z"
        fill="currentcolor"
      />
    </svg>
  );
};
